import { z } from 'zod';

import type { TranslationKey } from '@/i18n-key';
import type { User } from '@/types/directory/User';

export const SelectRevieweeFormFields = {
    selectedReviewees: 'selectedReviewees',
} as const;

const VALIDATION_ERROR_MESSAGE: TranslationKey = 'evaluation360SelectReviewee.validation.message';

export const selectRevieweeSchema = z.object({
    selectedReviewees: z
        .custom<User[]>((value) => Array.isArray(value))
        .refine((reviewees) => reviewees.length >= 1, {
            message: VALIDATION_ERROR_MESSAGE,
        }),
});

export type SelectRevieweeFormData = z.infer<typeof selectRevieweeSchema>;
